module.exports = __webpack_public_path__ + "img/giftsshop.f930eb5c.svg";